<template>
  <div id="year-nav-wrap" class="year-nav-wrap">
    <div class="decades">
      <div v-for="i in 6" :key="i" class="decade">
        <div
          class="decade-label"
          :data-decade="`${1970 + (i - 1) * 10}`"
          :class="{
            'curr-decade': period === (i - 1) * 10 + 1970,
            'prev-decade': period > (i - 1) * 10 + 1970,
          }"
          @click="() => click(1970 + (i - 1) * 10)"
        >
          <span>{{ `${1970 + (i - 1) * 10}s` }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    year: {
      required: true,
    },
  },
  computed: {
    period() {
      const { year } = this;
      let base = 1970;
      let increment = 10;
      let period;
      for (let i = 0; i <= 5; i++) {
        let curr = i * increment + base;
        let next = (i + 1) * increment + base;
        if (year >= curr && year < next) {
          period = curr;
        }
      }
      return period;
    },
  },
  methods: {
    click(decade) {
      this.$emit("scroll-to", decade);
    },
  },
};
</script>

<style>
.year-nav-wrap {
  opacity: 0;
  z-index: 999;
  color: #04f;
  position: fixed;
  top: 60px;
  height: calc(100vh - 60px);
}
.decades {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  /* height: calc(100vh - 60px - 120px);
  max-height: 160px; */
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  box-shadow: 0 0 10px rgb(0 0 0 / 10%);
  border-radius: 15px;
}
.decade {
  flex: 1 1 100%;
  margin: 8px 4px;
}
.decade:first-child {
  margin-top: 10px;
}
.decade:last-child {
  margin-bottom: 10px;
}
.decade-label {
  cursor: pointer;
  width: 10px;
  height: 10px;
  border-radius: 100%;
  position: relative;
  background: #e3e3e3;
  transition: background 0.19s ease-in-out;
}
.decade-label span {
  position: absolute;
  display: block;
  font-size: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  left: -100%;
  opacity: 0;
  visibility: hidden;
}
/* .decade-label:hover span {
  transform: translateY(-110%);
  opacity: 1;
  visibility: visible;
  transition: all 0.19s ease-in-out;
} */
.curr-decade {
  background: #04f;
  transition: background 0.19s ease-in-out;
}
.prev-decade {
  background: #04f;
  transition: background 0.19s ease-in-out;
}
.decades:before {
  content: "1970s";
  position: absolute;
  font-size: 0.875rem;
  color: #6f6f6f;
  top: -24px;
}
.decades:after {
  content: "2020s";
  position: absolute;
  font-size: 0.875rem;
  color: #6f6f6f;
  bottom: -24px;
}
.decade-label:hover {
  background: #bababa;
  transition: background 0.19s ease-in-out;
}
.curr-decade:hover,
.prev-decade:hover {
  background: #002999;
  /* background: #fed324; */
  transition: background 0.19s ease-in-out;
}

@media screen and (min-width: 1480px) {
  .year-nav-wrap {
    right: 48px;
    /* right: calc(((100vw - 15px - 1384px) / 2) + 15px); */
  }
}
@media screen and (min-width: 960px) and (max-width: 1479px) {
  .year-nav-wrap {
    right: calc((100vw - (100vw - 96px)) / 2 + 5px);
  }
}
@media screen and (min-width: 730px) and (max-width: 959px) {
  .year-nav-wrap {
    right: calc((100vw - (100vw - 80px)) / 2);
  }
}
@media screen and (max-width: 729px) {
  .year-nav-wrap {
    right: calc((100vw - (100vw - 48px)) / 2 + 10px);
  }
}
</style>
